module.exports = __webpack_public_path__ + "img/gallery-icon-08.3f8a6b84.png";